import React from 'react';
import AutomationRules from '../../../sections/AdminDashboard/Configuration/AutomationRules';

const Automation = () => <AutomationRules />;

export default Automation;
